import classNames from 'classnames';

import styles from './styles.module.scss';

interface DeliveryWindowForCheckoutProps {
  timeRange: string[];
}

const DeliveryWindowForCheckout = ({ timeRange }: DeliveryWindowForCheckoutProps) => {
  return (
    <>
      {timeRange.map((timeRangePart, i) => (
        <p key={timeRangePart} className={classNames('contrast', styles.timeRangePart)}>{`${
          i !== 0 ? ' ' : ''
        }${timeRangePart}`}</p>
      ))}
    </>
  );
};

export default DeliveryWindowForCheckout;
